import { useContext, useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from "react-redux";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';

import CategoriesSuper from '../Categories/CategoriesSuper';
import { getLabConfig, getCategories } from '../../utils/api';

import MenuContext from '../../store/MenuContext';
import LabIDContext from '../../store/LabIDContext';
import CategoryMenuClasses from '../Categories/CategoryMenu.module.css';


const CustomHome = () => {
	const navigate = useNavigate();
	const labid = useContext(LabIDContext);

	const menuTheme = useContext(MenuContext);

    return (
		<div className={CategoryMenuClasses.categoryItemHeaderColumn}>
			<div>Customizable Home Page</div>
			<div>
				<img src='../images/XYZLABS/xyzlabs_HOME.jpg' alt='Step 1' style={{ marginTop: '10px' }}/>
			</div>
		</div>
    );
};

export default CustomHome;